import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStaffAuth } from '../../context/StaffAuthContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import './staff.css';

export function StaffLoginPage() {
  const { login } = useStaffAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="staff-login-page">
      <Card className="staff-login-card">
        <h1>Panel Staff</h1>
        <p style={{ color: 'var(--color-text-muted)', marginTop: '0.25rem' }}>
          Acceso para agentes de soporte. Tras entrar, consulta el manual en la pestaña{' '}
          <strong>Manual</strong> del menú lateral.
        </p>
        <form onSubmit={handleSubmit} style={{ marginTop: '1.25rem', display: 'grid', gap: '0.75rem' }}>
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
          <Input
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          {error ? <p style={{ color: 'var(--color-danger)', margin: 0 }}>{error}</p> : null}
          <Button type="submit" disabled={loading}>
            {loading ? 'Entrando…' : 'Entrar'}
          </Button>
        </form>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          <Link to="/">← Volver a la web</Link>
        </p>
      </Card>
    </div>
  );
}
